/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/core";
import { useI18n } from "hooks/i18n/i18n";
import { Link } from "react-router-dom";

import { ActionButtonArea } from "../ProductInfo/components/ActionButtonArea";
import {
  blackActionButtonStyle,
  skeletonButtonStyle,
  whiteActionButtonStyle,
} from "./styles";

import type { FC } from "react";
import type { Options } from "utility/isFeatureEnabled/types/options";

type FeatureFlagName = Options["featureName"];

type Props = {
  eventId: string;
  hasBonusMedia: boolean;
  isLiveStreaming: boolean;
  isLoadingBonus: boolean;
  isPurchased: boolean;
  orderId: number;
  ticketId: string;
};

export const ProductActionButtons: FC<Props> = (props) => {
  const {
    eventId,
    hasBonusMedia,
    isLiveStreaming,
    isLoadingBonus,
    isPurchased,
    orderId,
    ticketId,
  } = props;

  const { t } = useI18n();

  const ticketHref = isLiveStreaming
    ? `/events/${eventId}/streaming`
    : "/account/ticket";

  const ticketLabel = isLiveStreaming
    ? t("settlementHistory.ticketLabel.streaming")
    : t("settlementHistory.ticketLabel.ticket");

  const FEATURE_FLAG_NAME: FeatureFlagName = "newPurchaseHistory";

  return (
    <ActionButtonArea>
      {isPurchased && (
        <Link to={ticketHref} css={blackActionButtonStyle}>
          {ticketLabel}
        </Link>
      )}
      {isPurchased && isLoadingBonus && <div css={skeletonButtonStyle} />}
      {isPurchased && !isLoadingBonus && hasBonusMedia && (
        <Link
          // TODO: 限定公開が不要になったら削除する
          // https://github.com/balus-co-ltd/spwn/issues/10899
          to={`/account/settlement/history/${orderId}/items/${ticketId}/downloads?events=${eventId}&${FEATURE_FLAG_NAME}`}
          css={blackActionButtonStyle}
        >
          {t("settlementHistory.digitalBonusDownload")}
        </Link>
      )}
      <Link to={`/events/${eventId}`} css={whiteActionButtonStyle}>
        {t("settlementHistory.eventPage")}
      </Link>
    </ActionButtonArea>
  );
};
